import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'truncate'
})
export class TruncatePipe implements PipeTransform {

  transform(value: string, limit = 25, endMin = 15, ellipsis = '...', middle = false): string {
    if (middle && value?.length > limit) { 
      const endLength = Math.min(endMin, limit);
      const startLength = limit - ellipsis?.length - endLength;
      const start = value?.substring(0, startLength); 
      const end = value?.substring(value?.length - endLength); 
      return `${start}${ellipsis}${end}`;
    } 
    return value?.length > limit ? value?.substring(0, limit) + ellipsis : value;
  }

}
